<div class="user-card-mini" [class.mobile]="deviceService.isMobile()">
  <div class="card-cover" (click)="navigateTo()"></div>
  <div class="avatar-wrap">
    <on-ui-cover [cover]="avatar"></on-ui-cover>
  </div>
  <div class="meta">
    <h5 class="name" [routerLink]="userLink">{{ userFullName }}</h5>
    <ng-template [ngIf]="isMe()" [ngIfElse]="sendMessage">
      <span class="its-you">{{ 'users.its-you' | customLocale }}</span>
    </ng-template>
    <ng-template #sendMessage>
      <span *ngIf="!isMeVersion()" class="send-message" (click)="onOpenChat(user.id)">{{ 'users.write' | customLocale }}</span>
    </ng-template>
  </div>
  <div class="action">
    <div class="top">
      <app-bookmark *ngIf="!isMe()" [item]="user" (favoriteChanged)="onFavoriteChanged()"></app-bookmark>
      <on-ui-card-menu>
        <div *ngIf="!isMe()" class="menu-item" (click)="openComplainForm()">{{ 'users.complain' | customLocale }}</div>
        <ng-template [ngIf]="isOwner()">
          <div class="menu-item" (click)="onToggleAlertOwnerToTeacher()">
            {{ 'school-participants-card.delete-owner' | customLocale }}
          </div>
        </ng-template>
        <ng-template [ngIf]="isTeacher()">
          <div class="menu-item" (click)="onToggleAlertTeacherToStudent()">
            {{ 'school-participants-card.delete-tutor' | customLocale }}
          </div>
        </ng-template>
      </on-ui-card-menu>
    </div>
    <div class="bottom">
      <app-subscribe *ngIf="user?.id" [user_id]="user?.id" [separate]="true"></app-subscribe>
    </div>
  </div>
</div>

<ng-template [ngIf]="complainFormOpened">
  <app-modal *ngIf="deviceService.isDesktop()"
             (closed)="closeComplainForm()"
             canClose="true"
             middle="true">
    <app-modal-body>
      <app-complaint-form [type]="'user'" (cancel)="closeComplainForm()"></app-complaint-form>
    </app-modal-body>
  </app-modal>

  <app-mobile-modal *ngIf="!deviceService.isDesktop()"
                    [titleVisible]="false"
                    (closed)="closeComplainForm()">
    <app-mobile-modal-body>
      <app-complaint-form [type]="'user'"
                          (cancel)="closeComplainForm()"></app-complaint-form>
    </app-mobile-modal-body>
  </app-mobile-modal>
</ng-template>

<app-alert *ngIf="alertTeacherToStudentOpened" type="error">
  <ng-container alert-title>{{ 'school-participants-card.add-student' | customLocale }}</ng-container>
  <ng-container alert-body>{{ 'school-participants-card.student-message' | customLocale }}</ng-container>
  <ng-container alert-buttons>
    <on-ui-button label="school-participants-card.close"
                  class="primary outline"
                  (onclick)="onToggleAlertTeacherToStudent()">
    </on-ui-button>
    <on-ui-button label="school-participants-card.apply"
                  class="danger"
                  (onclick)="removeTeacher()">
    </on-ui-button>
  </ng-container>
</app-alert>

<app-alert *ngIf="alertOwnerToTeacherOpened" type="error">
  <ng-container alert-title>{{ 'school-participants-card.add-tutor' | customLocale }}</ng-container>
  <ng-container alert-body>{{ 'school-participants-card.tutor-message' | customLocale }}</ng-container>
  <ng-container alert-buttons>
    <on-ui-button label="school-participants-card.close"
                  class="primary outline"
                  (onclick)="onToggleAlertOwnerToTeacher()">
    </on-ui-button>
    <on-ui-button label="school-participants-card.apply"
                  class="danger"
                  (onclick)="removeRole()">
    </on-ui-button>
  </ng-container>
</app-alert>
